import React, { useState, useEffect } from 'react';
import { TitleWrapper, Title, Wrapper, ButtonWrapper, } from './FilterSort.Styles';
import { Button, IconButton, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { FilterConfigurator } from './FilterConfigurator';
import { BottomSlidingPane } from '../commons/BottomSlidingPane';
import { FilterTable } from './FilterTable';
import { SnackbarComponent } from '../commons/SnackbarComponent';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CustomMaterialTable } from '../commons/CustomMaterialTable';
import { AccessRoles } from '../../constants';
import { AccountSelector } from '../commons/AccountSelector';
import { allDataFilter, isBaseURLAll, set_config_baseURL, set_account_override, config_baseURL, } from '../../api/utils';
import useNoInitialEffect from '../../hooks/react-mod-hooks';
export var FilterSortMainView = function (_a) {
    var onDiscardClick = _a.onDiscardClick, contactLists = _a.contactLists, getContactLists = _a.getContactLists, getFilters = _a.getFilters, filters = _a.filters, selectedAccount = _a.selectedAccount, setAccount = _a.setAccount, addFilter = _a.addFilter, deleteFilterByID = _a.deleteFilterByID, updateFilterByID = _a.updateFilterByID, accessLevel = _a.accessLevel, validateFilter = _a.validateFilter, returnedRecords = _a.returnedRecords;
    var _b = useState(false), readOnly = _b[0], setReadOnly = _b[1];
    var _c = useState(false), open = _c[0], setOpen = _c[1];
    var _d = useState(filters), filterData = _d[0], setFilterData = _d[1];
    var _e = useState({}), selectedFilter = _e[0], setSelectedFilter = _e[1];
    var _f = useState(false), copied = _f[0], setCopied = _f[1];
    var _g = useState(false), creating = _g[0], setCreating = _g[1];
    var _h = useState(false), openSnack = _h[0], setOpenSnack = _h[1];
    var _j = useState(false), openAlert = _j[0], setOpenAlert = _j[1];
    var _k = useState(''), snackMessage = _k[0], setSnackMessage = _k[1];
    var _l = useState(false), openDependencyList = _l[0], setOpenDependencyList = _l[1];
    var _m = useState([]), dependents = _m[0], setDependents = _m[1];
    var _o = useState(''), dataId = _o[0], setDataId = _o[1];
    var _p = useState('success'), severity = _p[0], setSeverity = _p[1];
    var _q = useState(config_baseURL()), accountURL = _q[0], setAccountURL = _q[1];
    var handleDiscard = function () {
        setOpen(false);
        setReadOnly(false);
        setSelectedFilter({});
        localStorage.setItem('onEditMode', '0');
    };
    var handlePaneOpen = function (readOnly) {
        setOpen(true);
        if (!readOnly && accessLevel !== AccessRoles.READ_ONLY)
            localStorage.setItem('onEditMode', '1');
    };
    var handleOpenSnack = function () {
        setOpenSnack(true);
    };
    var handleCloseSnack = function (_event, reason) {
        setOpenSnack(false);
    };
    var handleCloseAlert = function () {
        setOpenAlert(false);
    };
    useEffect(function () {
        getContactLists();
        getFilters();
    }, [selectedAccount]);
    useEffect(function () {
        setFilterData(filters);
    }, [filters]);
    useNoInitialEffect(function () {
        set_account_override('1');
        getContactLists();
        return function () { return set_account_override('0'); };
    }, [accountURL]);
    var handleAddCallback = function (data) {
        var status = data.action.type;
        if (status === 'ADD_FILTER_FULFILLED') {
            setSnackMessage('Filter Created!');
            setSeverity('success');
        }
        else if (status === 'VALIDATE_FILTER_FULFILLED') {
            return;
        }
        else {
            setSnackMessage('Filter Operation Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleUpdateCallback = function (data) {
        var status = data.action.type;
        if (status === 'UPDATE_FILTER_FULFILLED') {
            setSnackMessage('Filter Updated!');
            setSeverity('success');
        }
        else if (data.errorMessage && data.errorMessage.includes('409')) {
            setSnackMessage('Data state is stale; refresh & retry!');
            setSeverity('error');
        }
        else {
            setSnackMessage('Filter Update Failed!');
            setSeverity('error');
        }
        setOpenSnack(true);
    };
    var handleDeleteCallback = function (data) {
        var status = data.action.type;
        var response = data === null || data === void 0 ? void 0 : data.response;
        if (status === 'DELETE_FILTER_FULFILLED') {
            setSnackMessage('Filter Deleted!');
            setSeverity('success');
            setOpenSnack(true);
        }
        else if ((response === null || response === void 0 ? void 0 : response.status) !== 409 &&
            status !== 'DELETE_FILTER_FULFILLED') {
            setSnackMessage('Filter Deletion Failed!');
            setSeverity('error');
            setOpenSnack(true);
        }
        else {
            setSnackMessage('Filter Delete Cannot Be Completed');
            setSeverity('warning');
            setOpenSnack(true);
            setDependents(response.data.dependents.dependents.schedules);
            setOpenDependencyList(true);
        }
    };
    var handleDeleteClick = function (id) {
        deleteFilterByID(id, function (data) {
            handleDeleteCallback(data);
        });
    };
    var onHandleCopyToClipboard = function () {
        navigator.clipboard.writeText(JSON.stringify(dependents));
        setSnackMessage('Copied to Clipboard');
        setSeverity('success');
        setOpenSnack(true);
    };
    var handleOnRowEdit = function (row, isEdit) {
        handlePaneOpen();
        if (!isEdit) {
            setCopied(true);
            setCreating(true);
        }
        else if (isEdit) {
            setCreating(false);
            setCopied(false);
        }
        setSelectedFilter(row);
    };
    var alertReadOnly = function () {
        setSnackMessage('Access Denied');
        setSeverity('info');
        setOpenSnack(true);
    };
    return (React.createElement(Wrapper, null,
        React.createElement(TitleWrapper, null,
            React.createElement(Title, { variant: 'h6' }, "Filter and Sort"),
            React.createElement(ButtonWrapper, null,
                React.createElement(AccountSelector, { initialValue: selectedAccount, onValueChange: function (data) { return setAccount(data); }, disabled: open }),
                React.createElement(Button, { variant: 'contained', color: 'primary', disabled: open, onClick: function () {
                        setCreating(true);
                        setSelectedFilter({});
                        handlePaneOpen();
                    } }, accessLevel === AccessRoles.READ_ONLY ? 'See Form' : 'New Filter'))),
        React.createElement(BottomSlidingPane, { title: creating ? 'Create New Filter' : 'Update Filter', topOffSet: 126, 
            // readonly={readOnly || accessLevel === AccessRoles.READ_ONLY}
            open: open, onClose: function () { return handleDiscard(); }, component: React.createElement(FilterConfigurator, { readOnly: readOnly || accessLevel === AccessRoles.READ_ONLY, returnedRecords: returnedRecords, filters: allDataFilter(filters), contactLists: allDataFilter(contactLists), creating: creating, handleDiscard: function () { return handleDiscard(); }, addFilter: function (filter) {
                    addFilter(filter, function (data) {
                        handleAddCallback(data);
                    });
                }, validateFilter: function (filter, callback) {
                    validateFilter(filter, function (data) {
                        callback(data);
                        handleAddCallback(data);
                    });
                }, updateFilterByID: function (editedFilterConfig, id, initialFilterConfig) {
                    return updateFilterByID(editedFilterConfig, id, function (data) {
                        handleUpdateCallback(data);
                    }, initialFilterConfig);
                }, copied: copied, selectedRow: selectedFilter, onAlert: function (data, severity) {
                    setSnackMessage(data);
                    setSeverity(severity);
                    setOpenSnack(true);
                }, onAccountChange: function (url) { return setAccountURL(url); } }) },
            React.createElement(FilterTable, { filterData: filterData, contactLists: contactLists, openBar: open, deleteRow: function (_id) {
                    if (accessLevel === AccessRoles.READ_ONLY) {
                        alertReadOnly();
                    }
                    else {
                        setOpenAlert(true);
                        setDataId(_id);
                        var aFilter = filters.find(function (f) { return f.id === _id; });
                        if (isBaseURLAll() && aFilter.prjacc) {
                            set_config_baseURL(aFilter.prjacc.url);
                        }
                    }
                }, viewRow: function (_row) {
                    setReadOnly(true);
                    handlePaneOpen(true);
                    setSelectedFilter(_row);
                }, handleOnRowEdit: function (_row, isEdit) {
                    if (accessLevel === AccessRoles.READ_ONLY) {
                        alertReadOnly();
                    }
                    else {
                        handleOnRowEdit(_row, isEdit);
                    }
                } })),
        React.createElement(SnackbarComponent, { anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            }, open: openSnack, autoHideDuration: 6000, onAlertClose: handleCloseSnack, alertMessage: snackMessage, severity: severity }),
        React.createElement(Dialog, { open: openAlert, onClose: function () { return handleCloseAlert(); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, "Delete Filter"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Are you sure you want to delete this filter?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return handleCloseAlert(); }, color: 'primary' }, "Disagree"),
                React.createElement(Button, { onClick: function () {
                        handleCloseAlert();
                        handleDeleteClick(dataId);
                    }, color: 'primary', autoFocus: true }, "Agree"))),
        React.createElement(Dialog, { open: openDependencyList, onClose: function () { return setOpenDependencyList(false); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { disableTypography: true, style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    paddingRight: 5
                } },
                React.createElement(Typography, { variant: 'h6' }, "Dependents"),
                React.createElement(IconButton, { "aria-label": 'close', onClick: function () { return setOpenDependencyList(false); } },
                    React.createElement(Close, null))),
            React.createElement(DialogContent, { dividers: true },
                React.createElement(DialogContentText, { id: 'alert-dialog-description' },
                    React.createElement(CustomMaterialTable, { rows: dependents, columns: [
                            { label: 'Schedule ID', value: 'scheduleId' },
                            { label: 'Schedule Name', value: 'scheduleName' },
                        ] }))),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return onHandleCopyToClipboard(); }, color: 'primary' }, "Copy To Clipboard")))));
};
FilterSortMainView.defaultProps = {};
//# sourceMappingURL=FilterSort.js.map